export default function uniqueSchematicNameDirective(
  $q,
  bcpDataService,
) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link,
  };

  function link(scope, element, attributes, ngModel) {
    const assessmentId = attributes.assessmentId || 0;
    const schematicId = attributes.schematicId || 0;
    ngModel.$asyncValidators.bcpSchematicUniqueName = (modelValue) => {
      const defer = $q.defer();
      bcpDataService.checkSchematicExists(assessmentId, schematicId, modelValue).then((data) => {
        if (data && data.data.result === false) {
          defer.resolve();
        } else {
          defer.reject();
        }
      }).catch(defer.reject);
      return defer.promise;
    };
  }
}

export const name = 'bcpSchematicUniqueName';

uniqueSchematicNameDirective.$inject = [
  '$q',
  'bcpDataService',
];
